export default __webpack_public_path__ + "static/media/LoadMore.4df2c363.svg";